import axios from "axios";
import { resolveStations } from "lib/resolve";
import t from "lib/i18n";

const cache = {};
const locationCache = {};

const noResults = [
  {
    name: t("station.noResults"),
    disabled: true,
  }
];

export const MinSearchLength = 3;

export const getStations = async (search = "", maxResults = 10, apiUrl, type = "Origin") => {
  let safeSearch = search.trim();

  if (safeSearch.length < MinSearchLength) {
    return [];
  }

  const params = {
    search: safeSearch,
    type,
  };

  let response;

  if (!cache[`${safeSearch}-${type}`]) {
    try {
      response = await axios.get(`${apiUrl}/config/stations`, { params });
      //   response = {
      //     data: {
      //       result: [{ station: "x" }, { station: "y" }],
      //       links: {
      //         x: { name: "Station X", crs: "XST", nlc: 1000 },
      //         y: { name: "Station Y", crs: "YYY", nlc: 1000 }
      //       }
      //     }
      //   };
      cache[`${safeSearch}-${type}`] = response;
    } catch (e) {
      console.error("Cannot fetch station");
    }
  } else {
    response = cache[`${safeSearch}-${type}`];
  }

  if ((resolveStations(response) ?? []).slice(0, maxResults).length) {
    return (resolveStations(response) ?? []).slice(0, maxResults);
  } else {
    return noResults;
  }
};

export const getHardCodedStations = async (search = "", stationsList) => {
  let safeSearch = search.trim();

  if (safeSearch.length < MinSearchLength) {
    return [];
  }

  const filterBy = term => term.toLowerCase().includes(safeSearch.toLowerCase());

  const result = stationsList.filter(e => filterBy(e.name) || filterBy(e.crs));

  if (result.length) {
    return result;
  } else {
    return noResults;
  }
};

export const getStationsFromLatLng = async ({ latitude, longitude, numStations = 5 }, apiUrl) => {
  let response;
  const cacheIndex = `${latitude}${longitude}${numStations}`;
  if (!locationCache[cacheIndex]) {
    try {
      const params = {
        latitude,
        longitude,
        num_stations: numStations
      };

      response = await axios.get(`${apiUrl}/config/stations`, { params });
      locationCache[cacheIndex] = response;
    } catch (e) {
      console.error("Cannot fetch station based on location");
    }
  } else {
    response = locationCache[cacheIndex];
  }

  return (resolveStations(response) ?? []).slice(0, numStations);
};

export const getStationByNlc = async (nlc, apiUrl, apiAccessToken) => {
  let response;

  const cachedResponse = cache[nlc];
  if (!cachedResponse) {
    try {
      response = await axios.get(`${apiUrl}/data/stations/${nlc}`, {
        headers: {
          'x-access-token': apiAccessToken
        }
      });
      cache[nlc] = response;
    } catch (e) {
      console.error("Cannot fetch station");
    }
  } else {
    response = cachedResponse;
  }

  if (!response) {
    return noResults;
  }

  return response.data.result;
};
